import SomeguidesList from "components/SomeguidesList"

const SomeguidesIndex = ({ pageContext }) => (
  <SomeguidesList items={pageContext.guideList} />
)

export default SomeguidesIndex
